<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='备忘录管理' label2="修改备忘录" url="/note/notelist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">标题：</label>
            <div class="col-xl-6">
              <el-form-item prop="title" :rules="{required: true, message: '标题不能为空', trigger: 'blur'}">
                <el-input v-model="form.title" placeholder="请输入标题"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">内容：</label>
            <div class="col-xl-6">
              <el-form-item prop="content" :rules="{required: true, message: '内容不能为空', trigger: 'blur'}">
                <el-input v-model="form.content" :rows="5" placeholder="请输入内容"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <el-button type="success" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NoteEdit',
    data() {
      return {
        form: {
          token: '',
          createuser: '',
          id:'',
          title: '',
          content: ''
        }
      }
    },
    methods: {
      Save: function() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.fullscreenLoading = true
            this.$http.post(this.$utils.Url.zpgl + '/api/APINote/Update', this.form)
              .then(res => {
                if (res.data.Code === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  console.log('保存成功')
                  this.$router.push('/main/note/notelist')
                } else {
                  this.$message({
                    message: res.data.Msg + '，' + res.data.Data,
                    type: 'error'
                  })
                }
                this.fullscreenLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                this.fullscreenLoading = false
              })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      LoadNote:function(){
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APINote/Info', this.form, function (data, model) {
          model.title = data.Data.Title
          model.content = data.Data.Content
          model.createuser = data.Data.createuser
        }, null, null, this.form)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      this.LoadNote()
    }
  }
</script>

<style>
</style>
